/**
 * Audio mixin
 *
 * Добавляет логику для записи и проигрывания аудио
 *
 */

import { FaceType } from '@pb/api/dist/src/services/face_recognize';

export default {
  staticData: () => ({
    audioRecordDuration: 0,
    audioRecordTimestamp: null,
    audioPlayingTimeout: null,
    prolongInteractionInterval: null,
  }),
  created() {
    this.initAudioRecorderActions();
  },
  methods: {
    async startAudioRecording(timeout = 120) {
      try {
        this.$robot.dialogService.abortRobotReplic();
        this.$robot.dialogService.muteOn();
        await this.$robot.audioService.start(timeout);
        this.setProlongInteractionInterval();
      } catch (e) {
        this.onAudioRecordingError?.(e);
      }
    },
    stopAudioRecording() {
      this.$robot.dialogService.muteOff();
      this.$robot.audioService.stop();
      this.clearProlongInteractionInterval();
    },
    startAudioPlaying(audio, volume = 60) {
      if (!audio) {
        console.error('Start playing without audio!');
        return;
      }
      const source = `file://${audio.fullpath}`;
      this.$robot.dialogService.abortRobotReplic();
      this.$robot.dialogService.externalPlay(source, volume);
      this.setAudioPlayingTimeout();
      this.onAudioPlayingStart?.();
    },
    stopAudioPlaying() {
      this.$robot.dialogService.externalPlayStop();
      this.clearAudioPlayingTimeout();
      this.onAudioPlayingStop?.();
    },
    onAudioRecordStarted() {
      this.audioRecordTimestamp = performance.now();
      this.onAudioRecordStart?.();
    },
    onAudioRecordReady(fullpath) {
      const duration = performance.now() - this.audioRecordTimestamp;
      this.audioRecordDuration = duration;
      this.onAudioRecordStop?.({ fullpath, duration });
    },
    setAudioPlayingTimeout() {
      this.audioPlayingTimeout = window.setTimeout(this.stopAudioPlaying, this.audioRecordDuration);
    },
    clearAudioPlayingTimeout() {
      window.clearTimeout(this.audioPlayingTimeout);
    },
    setProlongInteractionInterval() {
      // хак для автоматического продления взаимодействия при записи аудио
      this.prolongInteractionInterval = window.setInterval(this.prolongInteraction, 5000);
    },
    clearProlongInteractionInterval() {
      window.clearInterval(this.prolongInteractionInterval);
    },
    prolongInteraction() {
      const facesInfo = this.$robot.faceRecognizeService.getInfo();
      const faces = facesInfo.filter((face) => face.type > FaceType.None); // все лица (распознанные и нет)
      if (faces.length) {
        this.$robot.interactionService.start();
      }
    },
    initAudioRecorderActions() {
      const robotActions = [
        this.$robot.audioService.onAudioResponse(this.onAudioRecordReady),
        this.$robot.audioService.onRecordStart(this.onAudioRecordStarted),
        this.$robot.faceRecognizeService.onInfo(this.onFacesInfo),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearProlongInteractionInterval();
        this.clearAudioPlayingTimeout();
        this.stopAudioRecording();
        this.stopAudioPlaying();
      });
    },
  },
};
